import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import Content from "../sections/register/Content";
import Headerfour from "../layouts/Headerfour";

const Register = () => {
  return (
    <Fragment>
      <Helmet>
        <title>Buy Home For Less | Register</title>
        <meta name="description" content="#" />
      </Helmet>
      <Headerfour/>  
      <Content />
    </Fragment>
  );
};

export default Register;
